document.documentElement.classList.remove('no-js');

/* Change true to false to turn the scroll construction off. */
const rubyJoelMotionEnabled = true;

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.site-nav');

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open', !open);
    });
  }

  if (!rubyJoelMotionEnabled) return;

  const items = document.querySelectorAll(
    '.split-statement .section-label, ' +
    '.split-statement .section-title, ' +
    '.split-statement .statement-copy, ' +
    '.dark-section .eyebrow, ' +
    '.dark-section .section-title, ' +
    '.dark-section .package-row, ' +
    '.dark-section .process-card, ' +
    '.cards-section .section-label, ' +
    '.cards-section .section-title, ' +
    '.cards-section .project-card, ' +
    '.cta-section .eyebrow, ' +
    '.cta-section .section-title, ' +
    '.cta-section .pill'
  );

  if (!items.length) return;

  items.forEach((item) => item.classList.add('scroll-construct-item'));

  let frameRequested = false;

  const updateScrollConstruction = () => {
    frameRequested = false;

    const screenHeight = window.innerHeight;
    const startPoint = screenHeight * 0.88;
    const finishPoint = screenHeight * 0.42;
    const distance = window.innerWidth <= 620 ? 22 : 34;

    items.forEach((item) => {
      const top = item.getBoundingClientRect().top;
      const progress = Math.max(
        0,
        Math.min(1, (startPoint - top) / (startPoint - finishPoint))
      );

      item.style.setProperty('--scroll-opacity', progress.toFixed(3));
      item.style.setProperty(
        '--scroll-y',
        `${((1 - progress) * distance).toFixed(1)}px`
      );
    });
  };

  const requestUpdate = () => {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(updateScrollConstruction);
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);

  requestUpdate();
});